var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"strikethrough-price line-through text-EXPONDO-black leading-6",class:[{
    'hidden md:block': _vm.isHiddenOnMobile,
  }, _vm.secondaryPriceTextSize],attrs:{"data-testid":"strikethroughPrice"}},[_vm._v("\n  "+_vm._s(_vm.price)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }